
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[orgSlug]",
      function () {
        return require("private-next-pages/[orgSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[orgSlug]"])
      });
    }
  